import React, { useState, useEffect, useCallback, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import GroupItem from './GroupItem';
import Popup from 'reactjs-popup';

import '../../../node_modules/reactjs-popup/dist/index.css';
import '../../../node_modules/ag-grid-community/styles/ag-grid.css';
import '../../../node_modules/ag-grid-community/styles/ag-theme-alpine.css';


const GroupHistory = (props) => {
    const gridRef = useRef();
    const [rowData, setRowData] = useState();
    const [loading, setLoading] = useState(false);

    const gridCellRenderer = (params) => {
        if (params.value) {
            let _value = '<span title="' + params.value + '">' + params.value + '</span>';
            return <Popup trigger={<div dangerouslySetInnerHTML={{ __html: _value }}></div>} modal>{close => (<GroupItem data={params.data} onClose={() => { close(); }}></GroupItem>)}</Popup>;
        }
    }

    const columnDefs = [
        { headerName: 'Group Name', field: 'groupName', filter: true, width: 250, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Action', field: 'actionName', filter: false, width: 90, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Date-Time', field: 'actionDateTime', filter: false, width: 165, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Action By', field: 'modifiedBy', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true },
        { headerName: 'Details', field: 'details', filter: false, cellRenderer: p => gridCellRenderer(p), resizable: true }
    ];

    const cellClickedListener = useCallback(event => {
        if (event.colDef.field === 'edit-button') {
            alert("You want to edit: " + event.data.id);
        }
        else if (event.colDef.field === 'delete-button') {
            alert("You want to delete: " + event.data.id);
        }
    }, []);

    useEffect(() => {
        setLoading(props.loading);
    }, [props]);

    useEffect(() => {
        if (loading) {
            fetch('/api/group/histories')
                .then(result => result.json())
                .then(rowData => {
                    console.log("Group history is loading");
                    setRowData(rowData.data);
                    setLoading(false);
                    //gridRef.current.api.sizeColumnsToFit();
                })
        }
    }, [loading]);

    const gridOptions = {
        columnDefs: columnDefs,
        pagination: true,
        rowSelection: 'single',
        enableFilter: true,
        cacheBlockSize: 25,
        paginationPageSize: 25,
        getRowHeight: (params) => 25
    }

    return (
            <div className="ag-theme-alpine" style={{ height: "100%" }}>
                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    onCellClicked={cellClickedListener}
                    gridOptions={gridOptions}
                />
            </div>
    );
};

export default GroupHistory;